import React from 'react';
import { PPUploader } from "processor-plataform-ui";
import "./index.css";

interface Props {
    handleOk: Function,
    handleClose: Function,
}

interface File {
    id: number,
    path: string,
    name: string,
    size: number,
    type: string,
    lastModifiedDate: Date
}

const SolicitationDetailsAddAttachment: React.FC<Props> = (props) => {
    const handleFiles = (files_: File[]) => {
        props.handleOk(files_);
    }
    
    return (
        <div> 
            <PPUploader
                onDropFile={(files: File[]) => handleFiles(files)}
                promptMessage={"Solte o arquivo aqui (máx. 10MB)"}
                maxSize={10240}
                largeFile={"Este componente não suporta arquivos maiores que 10Mb."}
            />
        </div>
    );
};

export default SolicitationDetailsAddAttachment;